import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { UserSettings } from "../models/user-setting.model";

const STORE_KEY = 'userSettingValue';

@Injectable({
    providedIn: 'root'
})
export class UserSettingService {

    currentUserSelection$: Observable<UserSettings>;

    get userSettingValue(): any {
        const storedValue = localStorage.getItem(STORE_KEY);
        return storedValue ? JSON.parse(storedValue) : null;
    }

    set userSettingValue(userSelection: UserSettings) {
        localStorage.setItem(STORE_KEY, JSON.stringify(userSelection));
    }

    updateSelection(updatedSelection: Partial<UserSettings>) {
        const currentSelection = this.userSettingValue;

        // Implement your logic to update the selection here
        // For example, you can merge the existing selection with the updated one
        const newSelection = { ...currentSelection, ...updatedSelection };

        // Update the userSettingValue using the setter
        this.userSettingValue = newSelection;
    }

    removeUserSettingsFromStore() {
        localStorage.removeItem(STORE_KEY);
    }
}